/*
 * Project: forca
 * File Created: Thursday, 28th April 2022 2:45:58 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import { NemIDProps } from './nemid.definition';

export const NemID = (props: NemIDProps) => {
	const {
		currentBlock,
		classBlock,
		//ticket,
		ssoUrlGenerated,
		visFejl,
		submitForm
	} = props;

	const renderError = () => (
		<div className={ `${classBlock}__Error` }>
			<div dangerouslySetInnerHTML={ { __html: currentBlock.pensionsinfoFejlTekst } } />
		</div>
	);

	return (
		<div className={ `${classBlock}-Pensioninfo` }>
			<div dangerouslySetInnerHTML={ { __html: currentBlock.pensionsinfoTekst } } />
			{ ssoUrlGenerated && (
				<button className="square-button button-type-3" type="button" onClick={ () => submitForm(event) } >
					{ currentBlock.pensionsinfoKnapLabel }
				</button>
			) }
			{ visFejl && renderError() }
		</div>
	);
};

export default NemID;